"use client";

import classNames from "classnames";
import PAImage from "component/design-system/images/PAImage";
import PAText from "component/design-system/typography/PAText/PAText";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useRef } from "react";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import { b2bUrl } from "util/url/static-urls";
import styles from "./business-tabs.module.scss";

const tabData = [
  {
    label: "New Order", url: b2bUrl, icon: "fa-first-order", image: "/cms/pubicImages/images/NewOrder.svg%2Bxml",
  },
  {
    label: "Orders", url: "/account/orders", icon: "fa-archive", image: "/cms/pubicImages/images/Orders.svg%2Bxml",
  },
  {
    label: "Returns", url: "/account/returns", icon: "fa-file-text", image: "/cms/pubicImages/images/Return.svg%2Bxml",
  },
  {
    label: "Invoices", url: "/account/invoices", icon: "fa-file-text", image: "/cms/pubicImages/images/Invoice.svg%2Bxml",
  },
];

function BusinessTabs() {
  const { asPath } = useRouter();
  const currentTab = tabData.findIndex((tab) => tab.url === asPath.split("?")[0]);
  const activeTab = currentTab === -1 ? 0 : currentTab;

  const activeTabRef = useRef(null);

  useEffect(() => {
    // Scroll to Active Tab in mobile view
    activeTabRef?.current?.scrollIntoView();
  }, [activeTab]);

  return (
    <div className={styles.tabs_container}>
      {tabData.map((tab, idx) => (
        (<Link
          href={tab.url}
          key={tab.label}
          className={classNames(styles.tab_link, {
            [styles.active_tab]: idx === activeTab,
          })}
          ref={idx === activeTab ? activeTabRef : null}>

          <PAImage
            src={getRelativeImagePath(tab.image)}
            width={27}
            height={27}
            alt={tab.label}
          />
          <PAText className={styles.tab_label}>{tab.label}</PAText>

        </Link>)
      ))}
    </div>
  );
}

export default BusinessTabs;
